import { AuthBEAPIClient, BEAPIClient, handleResponseSuccess } from './BEClient'
import { API_ENDPOINTS } from './constants'

export interface ISpendLimit {
  monthly_limit: number | null
}

export interface IUpdateUserDetails {
  email?: string
  address?: string
  phone_number?: string
}

export type ContactPayload = {
  name: string
  email: string
  message: string
  category?: string
}

export interface IWalletWithdrawal {
  transaction_id: number
  status: string
  amount_pence: number
  hosted_url: string
}

export interface IWalletWithdrawalRequestPayload {
  amount_pence: number
  account_holder_name: string
  account_number: string
  sort_code: string
}

export const userApi = {
  updateUserDetails: async (data: IUpdateUserDetails) => {
    const response = await AuthBEAPIClient.patch(API_ENDPOINTS.UPDATE_USER_PROFILE, data)
    return handleResponseSuccess(response)
  },
  getSpendLimit: async (): Promise<ISpendLimit> => {
    const response = await AuthBEAPIClient.get<ISpendLimit>(API_ENDPOINTS.GET_SPEND_LIMIT)
    return handleResponseSuccess(response)
  },
  setSpendLimit: async (monthly_limit: number | null): Promise<ISpendLimit> => {
    const response = await AuthBEAPIClient.patch<ISpendLimit>(API_ENDPOINTS.SET_SPEND_LIMIT, {
      monthly_limit,
    })
    return handleResponseSuccess(response)
  },
  postContactUs: async (partnerId: string | number, payload: ContactPayload) => {
    const response = await BEAPIClient.post<{ OK?: boolean }>(
      `/users/partners/${partnerId}/contact`,
      payload,
    )
    return handleResponseSuccess(response)
  },
  postWalletWithdrawal: async (amount_pence: number): Promise<IWalletWithdrawal> => {
    const response = await AuthBEAPIClient.post<IWalletWithdrawal>(
      API_ENDPOINTS.POST_WALLET_WITHDRAWAL,
      { amount_pence },
    )
    return handleResponseSuccess(response)
  },
  postWalletWithdrawalRequest: async (
    payload: IWalletWithdrawalRequestPayload,
  ): Promise<IWalletWithdrawal> => {
    const response = await AuthBEAPIClient.post<IWalletWithdrawal>(
      API_ENDPOINTS.POST_WALLET_WITHDRAWAL,
      payload,
    )
    return handleResponseSuccess(response)
  },
}
